var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showEditCategoriesModal ? _c('r-modal', {
    staticClass: "edit-categories-modal",
    attrs: {
      "title": _vm.$t('urlsTable.batchActions.editCategories.title'),
      "close-action-label": _vm.$t('global.actions.cancel'),
      "action-label": _vm.$t('urlsTable.batchActions.editCategories.deleteCategories'),
      "alternate-action-label": _vm.$t('urlsTable.batchActions.editCategories.addCategories'),
      "action-disabled": _vm.disableAction,
      "alternate-action-disabled": _vm.disableAction,
      "fetching": _vm.loading
    },
    on: {
      "submit:alternate": _vm.onAddCategories,
      "submit": _vm.onRemoveCategories,
      "close": _vm.closeEditCategoriesModal
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('label', [_vm._v(_vm._s(_vm.$t('urlsTable.batchActions.editCategories.subTitle')))]), _c('r-error-message', {
          attrs: {
            "errors": [_vm.error]
          }
        }), _c('div', {
          staticClass: "mt-3"
        }, [_c('categories-dropdown', {
          on: {
            "change": _vm.onSelectCategory,
            "open:create-category-modal": _vm.onClickCreateNewCategory
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 919612692)
  }) : _vm._e(), _vm.showEditCategoriesAlertModal ? _c('r-modal', {
    staticClass: "create-product-alert-modal",
    attrs: {
      "title": _vm.alertTitle
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex justify-center align-center"
        }, [_vm._v(" " + _vm._s(_vm.alertSuccessMessage) + " ")])];
      },
      proxy: true
    }, {
      key: "customActions",
      fn: function fn() {
        return [_c('r-button', {
          staticClass: "close-btn",
          attrs: {
            "outlined": true,
            "label": _vm.$t('global.actions.backToData')
          },
          on: {
            "click": _vm.closeAlertModal
          }
        })];
      },
      proxy: true
    }], null, false, 2512454546)
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }